// import React, { useContext, useEffect, useMemo } from 'react';
// import { GetToken } from 'src/helpers/request';

// export const SocketContext = React.createContext(null);
// export const useSocketProvider = () => useContext(SocketContext);
// import socketIOClient from 'socket.io-client';
// import { SOCK_POINT } from 'src/module/config';


// const SocketProviders = ({ children }) => {
//   const token = GetToken();
//   const urlSearchParams = new URLSearchParams(window.location.search);
//   const params = Object.fromEntries(urlSearchParams.entries());

//   const socket = useMemo(() => {
//     const s = socketIOClient(SOCK_POINT, {
//       autoConnect: false,
//       transports: ['websocket'],
//       auth: {
//         ...(token && { Authorization: 'Bearer ' + token?.token }),
//         MyIdReseller: params?.id_reseller,
//       },
//       transportOptions: {
//         polling: {
//           extraHeaders: {
//             ...(token && { Authorization: 'Bearer ' + token?.token }),
//           },
//         },
//       },
//     });

//     return s;
//   }, [token?.token, params?.id_reseller]); // atau [] jika hanya ingin satu kali

//   useEffect(() => {
//     socket.connect();

//     socket.on('connect', () => {
//       console.log('[CLIENT] Connected to socket.io server:', socket.id);
//     });

//     socket.on('connect_error', (err) => {
//       console.error('[CLIENT] Connection error:', err.message);
//     });

//     socket.on('disconnect', (reason) => {
//       console.warn('[CLIENT] Disconnected:', reason);
//     });

//     return () => {
//       socket.disconnect();
//     };
//   }, [socket]);

//   return (
//     <SocketContext.Provider value={{ socket }}>
//       {children}
//     </SocketContext.Provider>
//   );
// };

// export default SocketProviders;

import React, { createContext, useContext, useEffect, useRef } from 'react';
import socketIOClient from 'socket.io-client';
import { GetToken } from 'src/helpers/request';
import { SOCK_POINT } from 'src/module/config';

export const SocketContext = createContext(null);
export const useSocketProvider = () => useContext(SocketContext);

const SocketProviders = ({ children }) => {
  const socketRef = useRef(null);
  const token = GetToken();

  if (!socketRef.current) {
    socketRef.current = socketIOClient(SOCK_POINT, {
      transports: ['websocket'],
      autoConnect: false,
      auth: {
        ...(token && { Authorization: 'Bearer ' + token.token }),
      },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
    });
  }

  useEffect(() => {
    const socket = socketRef.current;

    if (!socket.connected) {
      socket.connect();
    }

    socket.on('connect', () => {
      console.log('[SOCKET] connected:', socket.id);
    });

    socket.on('disconnect', (reason) => {
      console.warn('[SOCKET] disconnected:', reason);
    });

    socket.on('connect_error', (err) => {
      console.error('[SOCKET] connect_error:', err.message);
    });

    return () => {
      socket.off('connect');
      socket.off('disconnect');
      socket.off('connect_error');
    };
  }, []);

  return (
    <SocketContext.Provider value={{ socket: socketRef.current }}>
      {children}
    </SocketContext.Provider>
  );
};

export default SocketProviders;
